const MEDIA_QUERY = {
  PHONE: '@media (max-width: 640px)',
  TABLET: '@media (max-width: 768px)',
  SMALL_LAPTOPS: '@media (max-width: 960px)',
};

const CONTACT = {
  PHONE: '(360) 789-3694',
  PHONE_HREF: 'tel:+13607893694',
  EMAIL: 'sungrownfarmswa@gmail.com',
};

const NAV_LINKS = [
  { href: '/#park', label: 'The park' },
  { href: '/#infrastructure', label: 'Infrastructure' },
  { href: '/#tenants', label: 'Tenants' },
  { href: '/#faq', label: 'FAQ' },
  { href: '/#location', label: 'Location' },
];

export {
  MEDIA_QUERY,
  CONTACT,
  NAV_LINKS,
};
